import { path, pathOr } from "ramda";
export var selectKeyCallbacks = path(["HotKeysReducer", "callbacks"]);
export var selectKeyBindings = path(["HotKeysReducer", "bindings"]);
export var selectUpdateCounter = function selectUpdateCounter(Selector) {
    return pathOr(0, ["HotKeysReducer", "updateCounter"], Selector);
};
